import type { PropsWithChildren } from "react";

import { Carousel } from "@similarweb/ui-components";

export const AlertsGroupCarousel = ({ children }: PropsWithChildren) => (
    <Carousel
        opts={{ align: "start", dragFree: true }}
        style={{ maxWidth: "100%" }}
    >
        <Carousel.Content>{children}</Carousel.Content>
        <Carousel.Previous style={{ left: "-52px" }} />
        <Carousel.Next style={{ right: "-8px" }} />
    </Carousel>
);
